export default {"src":"/_next/static/media/check.1eea0bfe.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};